import { VestingAllocationLegendStyles } from '@dealstack/frontend/shared/components/VestingTerms/TotalVestingAllocation/VestingAllocationLegend.styles.tsx';
import { Text } from '@mantine/core';

interface Props {
	color: string;
	label: string;
}

export const VestingAllocationLegend = ({ color, label }: Props) => (
	<VestingAllocationLegendStyles>
		<span className="indicator" style={{ backgroundColor: color }} />

		<Text fz={12} c="dark.0">
			{label}
		</Text>
	</VestingAllocationLegendStyles>
);
